import template from './contract_type.all.html'
import controller from './contract_type.all.controller'
import './contract_type.all.scss'

const contractTypeAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default contractTypeAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/all/contract_type.all.component.js